import axios from "axios"
export default class WebcamStream {

    treamId = null
    userId = null
    videoElement = null
    peerId = null
    call = null
    streamActive = false
    streamLoaded = false

    constructor(stream, userId, videoElement, turndata) {
        this.streamId = stream;
        this.userId = userId;
        this.videoElement = videoElement;
        this.turn = turndata;
        this.joinBrodcast();
    }

    joinBrodcast() {
        this.peer = new Peer({
            host: "dartboards.online",
            port: 9000,
            path: "/myapp",
            secure: true,
            debug: 1,
            config: {
                iceServers: [
                    {
                        urls: 'stun:stun.dartboards.online:3478'
                    },
                    {
                        urls: this.turn.url,
                        username: this.turn.username,
                        credential: this.turn.credential,
                    }
                ], 'sdpSemantics': 'unified-plan' }
        });

        this.peer.on('open', (id) => {
            console.log('My peer ID is: ' + id);
            this.peerId = id

            console.log("starting webcamstream", this.userId, this.streamId)
            this.streamActive = true;
            axios.post("/stream-request", {peerId: this.peerId, userId: this.userId, streamId: this.streamId})
        });

        this.peer.on("disconnected", () => {
            console.log("call: disconnected")
            // this.removeBroadcastVideo();
        })

        this.peer.on("error", (err) => {
            console.log("stream error: " + err.type)
        })

        this.peer.on('call', (call) => {
            call.answer();
            console.log("answered");

            console.log("call received", call)
            call.on('stream', (stream) => {
                console.log("stream received", stream)
                this.videoElement.srcObject = stream;
                console.log("Viewer Peer connected");
                this.streamLoaded = true;
            })

        })
    }

    closeCall() {
        console.log("disconnect from call");
        axios.post("/stream-end-call", {peerId: this.peerId, userId: this.userId, streamId: this.streamId})
    }

    removeBroadcastVideo() {
        console.log("removingBroadcast Video");
        this.closeCall()
        if (this.videoElement && this.videoElement.srcObject) {
            const tracks = this.videoElement.srcObject.getTracks();
            if (tracks)
                tracks.forEach((track) => {
                    track.stop();
                });
            this.videoElement.srcObject = null;
        }
        window.Echo.leave(`stream-signal-channel.${this.streamId}.${this.userId}`)
        this.streamActive = false
        this.peer.destroy()
    }

    leaveBroadcastVideo() {
        console.log("leaving Broadcast Video: " + this.streamId);
        if (this.videoElement && this.videoElement.srcObject) {
            const tracks = this.videoElement.srcObject.getTracks();
            if (tracks)
                tracks.forEach((track) => {
                    track.stop();
                });
            this.videoElement.srcObject = null;
        }
        this.peer.disconnect();
    }

    reconnectVideo() {
        this.peer.disconnect();
        this.closeCall();
        this.peer.reconnect();
    }

    // streamId = null
    // userId = null
    // turn = []
    // videoElement = null
    // streamingPresenceChannel = null
    // broadcasterPeer= null
    // broadcasterId = null
    // streamActive = false
    // streamLoaded = false

    // constructor(stream, userId, videoElement, turndata) {
    //     this.streamId = stream;
    //     this.userId = userId;
    //     this.videoElement = videoElement;
    //     this.turn = turndata;
    //     this.joinBroadcast()
    // }

    // joinBroadcast() {
    //     console.log("starting webcamstream")
    //     this.streamingPresenceChannel = window.Echo.join(
    //         `streaming-channel.${this.streamId}`
    //       ).here(() => {
    //           this.webcamOwnStream();
    //       })
    //     this.streamActive = true;
    //     this.initializeSignalOfferChannel()
    // }

    // webcamOwnStream() {
    //     axios.post("/users/sendcamrequest", {id: this.userId, streamId: this.streamId});
    // }

    // initializeSignalOfferChannel() {
    //     console.log("private channel init signal offer for " + `stream-signal-channel.${this.streamId}.${this.userId}`)
    //     window.Echo.private(`stream-signal-channel.${this.streamId}.${this.userId}`).listen(
    //         "StreamOffer",
    //         ({ data }) => {
    //             console.log("Signal Offer from private channel");
    //             if (!this.broadcasterId) {
    //             this.broadcasterId = data.broadcaster;
    //             this.createViewerPeer(data.offer, data.broadcaster);
    //             }
    //         }
    //     );
    // }

    // createViewerPeer(incomingOffer, broadcaster) {
    //     var peer = new Peer({
    //         initiator: false,
    //         trickle: false,
    //         config: {
    //           iceServers: [
    //             {
    //                 urls: 'stun:stun.dartboards.online:3478'
    //             },
    //             {
    //               urls: this.turn.url,
    //               username: this.turn.username,
    //               credential: this.turn.credential,
    //             },
    //           ],
    //         }
    //     });
    //     // Add Transceivers
    //     peer.addTransceiver("video", { direction: "recvonly" });
    //     peer.addTransceiver("audio", { direction: "recvonly" });
    //     // Initialize Peer events for connection to remote peer
    //     this.handlePeerEvents(
    //     peer,
    //     incomingOffer,
    //     broadcaster
    //     );
    //     this.broadcasterPeer = peer;
    // }

    // handlePeerEvents(peer, incomingOffer, broadcaster) {
    //     peer.on("signal", (data) => {
    //       axios
    //         .post("/stream-answer", {
    //           broadcaster,
    //           streamid: this.streamId,
    //           answer: data
    //         })
    //         .then((res) => {
    //           console.log(res);
    //         })
    //         .catch((err) => {
    //           console.log(err);
    //         });
    //     });
    //     peer.on("stream", (stream) => {
    //         console.log("stream should be loaded")
    //       // display remote stream
    //       this.videoElement.srcObject = stream;
    //       console.log(this.videoElement)
    //     });
    //     peer.on("track", (track, stream) => {
    //       console.log("onTrack");
    //     });
    //     peer.on("connect", () => {
    //       console.log("Viewer Peer connected");
    //       this.streamLoaded = true;
    //     });
    //     peer.on("close", () => {
    //       console.log("Viewer Peer closed");
    //       peer.destroy();
    //       this.removeBroadcastVideo();
    //     });
    //     peer.on("error", (err) => {
    //       console.log("handle error gracefully");
    //     });
    //     const updatedOffer = {
    //       ...incomingOffer,
    //       sdp: `${incomingOffer.sdp}\n`,
    //     };
    //     peer.signal(updatedOffer);
    //   }

    // removeBroadcastVideo() {
    //     console.log("removingBroadcast Video");
    //     if (this.videoElement) {
    //         const tracks = this.videoElement.srcObject.getTracks();
    //         if (tracks)
    //             tracks.forEach((track) => {
    //                 track.stop();
    //             });
    //         this.videoElement.srcObject = null;
    //     }
    //     window.Echo.leave(`streaming-channel.${this.streamId}`)
    //     window.Echo.leave(`stream-signal-channel.${this.streamId}.${this.userId}`)
    //     this.streamActive = false
    //     this.broadcasterPeer.destroy()
    // }
}
